import * as React from 'react';
import { observer } from 'mobx-react';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import { themeStore } from 'Models/ThemeStore';
import { useNavigate } from 'react-router-dom';
import Card from 'Views/Components/_HumanWritten/Card/Card';

export function PageNotFound() {
	const navigate = useNavigate();

	return (
		<>
			{/*
			 * No nav bar on this page. Its links don't work from here, so the only thing they do is
			 * invite a click that goes nowhere — "Go to home page" below is the way out.
			 */}
			<div className="body-content error-page">
				<div
					className="error-page__background"
					style={{
						backgroundImage: `url(${themeStore.errorPageBackgroundImageURL})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
					}}
				/>
				<div className="error-page__content">
					<Card>
						<h5>Whoops</h5>
						<p className="body--content">We can&#8217;t find this page.</p>
						<Button
							display={Display.Solid}
							colors={Colors.Primary}
							newStyles
							onClick={() => {
								navigate('/ferry-schedule');
							}}
						>
							Go to home page
						</Button>
					</Card>
				</div>
			</div>
		</>
	);
}

export default observer(PageNotFound);
